// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".match-title{height:2.3rem;line-height:2.3rem;font-size:1.05rem!important;background:#fff;border-bottom:4px solid #fff;padding-left:20px}.match-title i{color:#f32c6c;margin-right:15px;clear:both}.match-title .dot{width:10px;height:10px;background:#f32c6c;border-radius:50%;display:inline-block;margin-right:10px}", ""]);
// Exports
module.exports = exports;
